import { VFC } from "react";

import noop from "lodash/noop";

import { useSetFilterState } from "../store/brokerInsightsIndexFilterSlice";
import { useBrokerInsightsIndexSliceSelector } from "../store/brokerInsightsIndexStore";
import BrokerInsightsFilterBarView from "../views/BrokerInsightsFilterBarView";

const BrokerInsightsFilterBarContainer: VFC = () => {
  const { searchQuery, mode, selectedReport, reportTypes, lastRefreshedAt } = useBrokerInsightsIndexSliceSelector(
    (store) => store.brokerInsightsIndexFilterSlice
  );

  const setFilterState = useSetFilterState();

  if (!reportTypes || !selectedReport) {
    return null;
  }

  return (
    <BrokerInsightsFilterBarView
      isLoading={false}
      searchQuery={searchQuery}
      mode={mode}
      reportId={selectedReport?.id}
      reportTypes={reportTypes}
      selectedReport={selectedReport}
      lastRefreshedAt={lastRefreshedAt}
      onRefresh={noop}
      onChangeFilter={(changes) => {
        setFilterState({ ...changes });
      }}
    />
  );
};

export default BrokerInsightsFilterBarContainer;
